// Copyright (c) 2016 Deere & Company

import {combineReducers} from 'redux';
import {getCombinedReducers as getCombinedAdvancedClaimSummaryReducers} from './advanced-claim-summary/reducers';
import {getCombinedReducers as getCombinedAuditStatusReducers} from './audit-status/reducers';
import {getCombinedReducers as getCombinedAuditSummaryReducers} from './audit-summary/reducers';
import {getCombinedReducers as getCombinedBasicWarrantyEstimatorReducers} from './basic-warranty-estimator/reducers';
import {getCombinedReducers as getCombinedClaimHistoryReducers} from './claim-history/reducers';
import {getCombinedReducers as getCombinedCreditMemoReducers} from './credit-memo/reducers';
import {getCombinedReducers as getCombinedDealerTransferHistoryReducers} from './dealer-transfer-history/reducers';
import {getCombinedReducers as getCombinedDeliveryNoDocumentsReducers} from './delivery-no-documents/reducers';
import {getCombinedReducers as getCombinedDemoRentalHistoryReducers} from './demo-rental-history/reducers';
import {getCombinedReducers as getCombinedDuplicatePinPlateReducers} from './duplicate-pin-plate/reducers';
import {getCombinedReducers as getCombinedEmissionsPartSearchReducers} from './emissions-part-search/reducers';
import {getCombinedReducers as getCombinedLaborRateHistoryReducers} from './labor-rate-history/reducers';
import {getCombinedReducers as getCombinedLaborStatsReducers} from './labor-stats/reducers';
import {getCombinedReducers as getCombinedMaintenancePlanReducers} from './maintenance-plan/reducers';
import {getCombinedReducers as getCombinedMassChannelCustomerFollowUpReducers} from './mass-channel-customer-follow-up/reducers';
import {getCombinedReducers as getCombinedOpenPipProgramsReportReducers} from './open-pip-programs/reducers';
import {getCombinedReducers as getCombinedPartsCoverageSearchReducers} from './parts-coverage-search/reducers';
import {getCombinedReducers as getCombinedPinCrossReferenceReducers} from './pin-cross-reference/reducers';
import {getCombinedReducers as getCombinedPinsNotRegisteredReducers} from './pins-not-registered/reducers';
import {getCombinedReducers as getCombinedPipHistoryReducers} from './pip-history/reducers';
import {getCombinedReducers as getCombinedQuestionablePartReducer} from './questionable-part-search/reducers';
import {getCombinedReducers as getCombinedRegistrationsReviewReducers} from './registrations-review/reducers';
import {getCombinedReducers as getCombinedResponsibleDealerReducers} from './responsible-dealer/reducers';
import {getCombinedReducers as getCombinedSettlementNoRegistrationReducers} from './settlement-no-registration/reducers';
import {getCombinedReducers as getCombinedSpecialAllowanceClaimStatusReducers} from './special-allowance-claim-status/reducers';
import {getCombinedReducers as getCombinedUpdateMachineStatusHistoryReducers} from './update-machine-status-history/reducers';
import {getCombinedReducers as getCombinedWarrantyExpirationReducers} from './warranty-expiration/reducers';

export const getCombinedReducers = () =>
    combineReducers({
        advancedClaimSummary: getCombinedAdvancedClaimSummaryReducers(),
        auditStatus: getCombinedAuditStatusReducers(),
        auditSummary: getCombinedAuditSummaryReducers(),
        basicWarrantyEstimator: getCombinedBasicWarrantyEstimatorReducers(),
        claimHistory: getCombinedClaimHistoryReducers(),
        creditMemo: getCombinedCreditMemoReducers(),
        dealerTransferHistory: getCombinedDealerTransferHistoryReducers(),
        deliveryNoDocuments: getCombinedDeliveryNoDocumentsReducers(),
        demoRentalHistory: getCombinedDemoRentalHistoryReducers(),
        duplicatePinPlate: getCombinedDuplicatePinPlateReducers(),
        emissionsPartSearch: getCombinedEmissionsPartSearchReducers(),
        laborRateHistory: getCombinedLaborRateHistoryReducers(),
        laborStats: getCombinedLaborStatsReducers(),
        maintenancePlan: getCombinedMaintenancePlanReducers(),
        massChannelCustomerFollowUp: getCombinedMassChannelCustomerFollowUpReducers(),
        openPipProgramsReport: getCombinedOpenPipProgramsReportReducers(),
        partsCoverageSearch: getCombinedPartsCoverageSearchReducers(),
        pinCrossReference: getCombinedPinCrossReferenceReducers(),
        pinsNotRegistered: getCombinedPinsNotRegisteredReducers(),
        pipHistory: getCombinedPipHistoryReducers(),
        questionablePart: getCombinedQuestionablePartReducer(),
        registrationsReview: getCombinedRegistrationsReviewReducers(),
        responsibleDealer: getCombinedResponsibleDealerReducers(),
        settlementNoRegistration: getCombinedSettlementNoRegistrationReducers(),
        specialAllowanceClaimStatus: getCombinedSpecialAllowanceClaimStatusReducers(),
        updateMachineStatusHistory: getCombinedUpdateMachineStatusHistoryReducers(),
        warrantyExpiration: getCombinedWarrantyExpirationReducers()
    });



// WEBPACK FOOTER //
// ./src/reports/reports-reducers.js